import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Avatar, Button, Input } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

import { db, auth, storage } from './firebase';
import Post from './Post';
import Logo from './logo.png';
import Home from './home.png';
import './App.css';
import Footer from './Footer';
import UserProfile from './UserProfile';
import AppRight from './AppRight';
import TabPanel from './components/Tab/Tab';
import PetProfile from './Pet';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function App() {
  const dispatch = useDispatch();

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [posts, setPosts] = useState([]);
  const [open, setOpen] = useState(false);
  const [openSignIn, setOpenSignIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [user, setUser] = useState(null);
  const [image, setImage] = useState(null);
  const [userDetail, setUserDetail] = useState(null);

  // onChange(i, value, tab, ev) {
  //   console.log(arguments);
  // }

  // onActive(tab) {
  //   console.log(arguments);
  // }
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        //user logged in
        console.log('----auth:', authUser);
        dispatch({
          type: 'DROPDOWN_START',
          email: authUser.email,
        });
        setUser(authUser);
        if (authUser.email) {
          storage
            .ref(`avatars/${authUser.email}-avatar.png`)
            .getDownloadURL()
            .then((url) => {
              setImage(url);
              console.log('-----imageUrl:'.url);
            });

          db.collection('userprofile').onSnapshot((snapshot) => {
            snapshot.docs.map((doc) => {
              if (authUser.email === doc.data().userEmail) {
                setUserDetail(doc.data());
                console.log('-----userProfileDoc:', doc.data());
              }
            });
          });
        }
      } else {
        //user logged out
        setUser(null);
      }
    });
    return () => {
      unsubscribe();
    };
  }, [user, username]);

  // userEffect: run a piece of code based on a specific condition
  useEffect(
    () => {
      //this is where code runs
      db.collection('posts')
        .orderBy('timestamp', 'desc')
        .onSnapshot((snapshot) => {
          //every time a new post is added, it fires up onSnapshot
          setPosts(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              post: doc.data(),
            }))
          );
        });
    },

    [
      // this is condition
    ]
  );

  const signUp = (event) => {
    event.preventDefault();

    auth
      .createUserWithEmailAndPassword(email, password)
      .then((authUser) => {
        return authUser.user.updateProfile({
          displayName: username,
        });
      })
      .catch((error) => alert(error.message));

    setOpen(false);
  };

  const signIn = (event) => {
    event.preventDefault();

    auth
      .signInWithEmailAndPassword(email, password)
      .catch((error) => alert(error.message));

    setOpenSignIn(false);
  };
  const addImage = () => {
    document
      .getElementById('files')
      .addEventListener('change', handleChangeAvatar, false);
    document.getElementById('files').click();
  };
  const handleChangeAvatar = (e) => {
    if (e.target.files.length) {
      const files = e.target.files;
      imageUpload(files);
    }
  };
  const imageUpload = (image) => {
    const uploadTask = storage.ref(`avatars/${email}-avatar.png`).put(image[0]);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // const progress = Math.round(
        //   (snapshot.bytesTransfeered / snapshot.totalBytes) * 100
        // );
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref(`avatars/${email}-avatar.png`)
          .getDownloadURL()
          .then((url) => {
            setImage(url);
          });
      }
    );
  };
  return (
    <div className='app'>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div style={modalStyle} className={classes.paper}>
          <form className='app_signup'>
            <center>
              <img className='app_headerImage' src={Logo} alt='' />
            </center>
            <Input
              placeholder='Username'
              type='text'
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Input
              placeholder='Email'
              type='text'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              placeholder='Password (At least 6 characters)'
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <br></br>
            <center>
              <Button
                variant='contained'
                color='secondary'
                size='medium'
                style={{ minWidth: '100px', maxWidth: '120px' }}
                type='submit'
                onClick={signUp}>
                Sign Up
              </Button>
            </center>
          </form>
        </div>
      </Modal>

      <Modal open={openSignIn} onClose={() => setOpenSignIn(false)}>
        <div style={modalStyle} className={classes.paper}>
          <form className='app_signup'>
            <center>
              <img className='app_headerImage' src={Logo} alt='' />
            </center>

            <Input
              placeholder='Email'
              type='text'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              placeholder='Password'
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <br></br>
            <center>
              <Button
                variant='contained'
                color='secondary'
                size='medium'
                style={{ minWidth: '100px', maxWidth: '120px' }}
                type='submit'
                onClick={signIn}>
                Log In
              </Button>
            </center>
          </form>
        </div>
      </Modal>

      <div className='app_header'>
        <Button href='/' style={{ backgroundColor: 'transparent' }}>
          <img className='app_headerImage' src={Logo} alt='' />
        </Button>

        {user && (
          <div style={{ display: 'flex', width: '65%' }}>
            <Button
              href='/'
              className='app_headerbutton'
              style={{ backgroundColor: 'transparent' }}>
              <img className='app_headerhome' src={Home} alt='' />
            </Button>
            <Button href='/profile' style={{ backgroundColor: 'transparent' }}>
              <Avatar src={image} />
            </Button>
          </div>
        )}

        <div className='app_headerButton'>
          {user ? (
            <Button
              href='/'
              variant='contained'
              color='secondary'
              size='medium'
              style={{ minWidth: '100px', maxWidth: '120px' }}
              onClick={() => auth.signOut()}>
              Log out
            </Button>
          ) : (
            <div className='app_loginContainer'>
              <div className='buttons'>
                <Button
                  variant='contained'
                  color='secondary'
                  size='medium'
                  style={{ minWidth: '100px', maxWidth: '120px' }}
                  onClick={() => setOpenSignIn(true)}>
                  Log In
                </Button>
              </div>
              <div className='buttons'>
                <Button
                  variant='contained'
                  color='secondary'
                  size='medium'
                  style={{ minWidth: '100px', maxWidth: '120px' }}
                  onClick={() => setOpen(true)}>
                  Sign Up
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className='app_posts'>
        {user && <div
          className='profile_avatar'
          style={{ width: '24%', textAlign: 'center', paddingTop: '2%' }}>
          <input type='file' id='files' style={{ display: 'none' }} />
          <Button component='label'>
            <Avatar style={{ width: '270px', height: '270px' }} src={image} />
            <button style={{ display: 'none' }} onClick={addImage}></button>
          </Button>
          <br></br>
          <br></br>
          <br></br>
          <div style={{ width: '100%', display: 'flex' }}>
            <span
              style={{
                color: '#bdbdbd',
                marginTop: '-12px',
                fontFamily: 'fangsong',
                paddingRight: '6%',
                paddingLeft: '11%',
              }}>
              About
            </span>
            <hr style={{ width: '62%', height: '0px', float: 'right' }}></hr>
          </div>
          <br></br>
          <div
            style={{
              borderStyle: 'groove',
              paddingTop: '5%',
              height: '40%',
              width: '80%',
              marginLeft: '11%',
            }}></div>
        </div> }

        <div className='app_profileRight'>
          <div style={{ height: '310px', paddingTop: '5%' }}>
            {user && (
              <div style={{ display: 'flex' }}>
                <h3
                  style={{
                    paddingTop: '5%',
                    fontSize: 'xx-large',
                    fontFamily: 'Open Sans',
                    width:'10%',
                    color:'grey'
                  }}>
                  {user.displayName}
                </h3>
                <h4
                  style={{
                    paddingTop: '6.5%',
                    // marginTop: 'auto',
                    color: 'rgb(189, 189, 189)',
                    fontSize:'larger'
                  }}>
                  Zip Code&nbsp;&nbsp;&nbsp; {userDetail && userDetail.zipCode}
                </h4>

              </div>
            )}

            {user && (
              <div style={{ display: 'flex' }}>
                <h4 style={{ color: 'rgb(107, 125, 222)' }}>
                  Email &nbsp;&nbsp;&nbsp;  {user.email}
                </h4>
                {/* <h5 style={{ color: 'rgb(107, 125, 222)', marginTop: 'auto' }}>
                  {user.email}
                </h5> */}
              </div>
            )}
            {/* {user && <h3 style={{ paddingTop: '5%' }}> {user.email} </h3>} */}
          </div>
          <br></br>
          <br></br>
          {user && (
            <TabPanel>
              <div title='User Profile'>
                {user && 
                  <UserProfile
                    username={user.displayName}
                    email={user.email}
                    posts={user.posts}
                    user={user}
                  />
                }
              </div>
              <div title='Pet Profile'>
                {user && 
                  <PetProfile
                    username={user.displayName}
                    email={user.email}
                    posts={user.posts}
                    user={user}
                  />
                 }
              </div>
            </TabPanel>
          ) }
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
